
import { mapState, mapMutations } from 'vuex';
import Field from '@/components/ui/field.vue';

export default {
  name: 'KwanzaGpo',

  components: {
    Field,
  },

  data() {
    return {
      phone: null,
      active: false,
      message: null,
    };
  },

  computed: {
    ...mapState(['order', 'patientId', 'marketing', 'method']),
  },

  watch: {
    phone() {
      this.$emit('clearErrors');
    },
    method(value) {
      this.active = value === 'kwanza-gpo';
    },
    active(value) {
      if (value) {
        this.setMethod('kwanza-gpo');
      } else if (this.method === 'kwanza-gpo') {
        this.setMethod('null');
      }
    },
  },

  mounted() {
    this.phone = '244900000000'; // TODO: remove test phone number this.order?.address?.phone;

    if (this.method === 'kwanza-gpo') {
      setTimeout(() => {
        this.active = true;
      }, 500);
    }
  },

  methods: {
    ...mapMutations(['setMethod']),

    async pay() {
      this.message = this.$t('checkout.gpo_info');
      this.$bolev.metaEvent({
        type: 'paymentInitiated',
        patientId: this.patientId,
      });
      try {
        const { data } = await this.$bolev.kwanzaGpo({
          phone: this.phone,
          patientId: this.patientId,
          orderId: this.order.id,
          marketing: this.marketing,
        });
        switch (data.state) {
          case 'succeeded':
            this.message = null;
            this.$emit('success', { method: 'kwanza-gpo', state: data.state });
            break;
          default:
            this.$emit('fail', data.reason);
            break;
        }
      } catch (e) {
        this.$emit('fail', e.response.data.message);
      }
    },
  },
};
